"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEvent = void 0;
function trackEvent(event, data) {
    if (data === void 0) { data = {}; }
    var w = window;
    if (typeof w.dataLayer !== 'undefined') {
        try {
            w.dataLayer.push(__assign(__assign({}, data), { event: event }));
        }
        catch (err) {
            // do nothing
        }
    }
}
exports.trackEvent = trackEvent;
